import { IDotXetHocVuUpdateTrangThaiRequest } from "../../../model/request/xet-hoc-vu/IDotXetHocVuUpdateTrangThaiRequest";
import { IDotXetHocVu } from "../../../model/response/xet-hoc-vu/IDotXetHocVu";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotXetHocVuActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDotXetHocVu[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IDotXetHocVu | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDotXetHocVu,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    UPDATE_TRANG_THAI_START: {} as IDotXetHocVuUpdateTrangThaiRequest,
    UPDATE_TRANG_THAI_SUCCESS: undefined,
    UPDATE_TRANG_THAI_ERROR: "",
}

export const eDotXetHocVuActionIds = generateActionTypeIds(eDotXetHocVuActionsObj, "DOT_XET_HOC_VU");
export type IDotXetHocVuActionTypes = IGenericActionType<typeof eDotXetHocVuActionsObj, "DOT_XET_HOC_VU">;